<template>
  <v-content>
    <v-alert
      :color="'warning'"
      class="block-login"
      v-model="alert"
      transition="scale-transition"
    >
      <div class="manutention">
        <i class="material-icons">warning</i>
        <p>SISTEMA EM MANUTENÇÃO</p>
      </div>
      <div class="manutention-subtext">
        <p>
          Nosso Portal ficará indiponível para a atualização de suas
          funcionalidades de 23/04/2020 até às 08:00 de 27/04/2020.
        </p>
        <br />
        <p>Agradecemos a compreensão.</p>
      </div>
    </v-alert>
  </v-content>
</template>

<script lang="js">
export default {
  name: "FormAlertFullBlockManutention",
  data: () => ({
    alert: true,
  }),
  mounted() {
    if (localStorage.getItem("me")) {
      localStorage.clear();
      this.$router.push({ name: "ConnectionGuard" });
      delete this.axios.defaults.headers.common["Authorization"];
    }
  },
};
</script>

<style lang="scss" scoped>
#jns {
  .block-login {
    background-clip: padding-box;
    border-bottom: 20vh solid rgba(0, 0, 0, 0.87) !important;
    border-top: 20vh solid rgba(0, 0, 0, 0.87) !important;
    padding: 2vh 0;
    font-size: 2vh;
    height: 100vh !important;
    background-color: #061d45 !important;
  }

  .v-alert {
    position: fixed;
    width: -webkit-fill-available;
    z-index: 51;
    border-radius: 4px;
    top: -5px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
    font-weight: bold;
    text-align: center;

    .manutention {
      font-size: 3rem;
      margin-bottom: 5vh;

      i {
        color: #f1e41e;
        font-size: 10rem;
      }
    }

    .manutention-subtext {
      font-size: 1.8rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FormAlertFullBlockManutention.vue